module.exports = __webpack_public_path__ + "static/media/card-content-file.b2b37ca7.svg";